import { render, staticRenderFns } from "./backoffice-autorizacao-base.vue?vue&type=template&id=167c026e"
import script from "./backoffice-autorizacao-base.vue?vue&type=script&lang=ts"
export * from "./backoffice-autorizacao-base.vue?vue&type=script&lang=ts"
import style0 from "./backoffice-autorizacao-base.vue?vue&type=style&index=0&id=167c026e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports